export const downloadBlob = (blob: Blob, fileName: string) => {
	const fileURL = window.URL.createObjectURL(blob)
	// Setting various property values
	let alink = document.createElement('a')
	alink.href = fileURL
	alink.download = fileName
	alink.click()
}
